function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.7437 16.25L13.8796 11.3843C14.574 10.2502 14.995 8.92883 14.995 7.5C14.995 3.35877 11.6367 0 7.4975 0C3.35765 0 0 3.35877 0 7.5C0 11.6406 3.35765 15 7.4975 15C8.92585 15 10.2468 14.5789 11.3805 13.8867L16.2446 18.75C16.5863 19.0918 17.1525 19.0894 17.4942 18.75L18.7437 17.5C19.0854 17.1582 19.0854 16.5918 18.7437 16.25ZM7.4975 12.5C4.73719 12.5 2.49917 10.2612 2.49917 7.5C2.49917 4.73877 4.73719 2.5 7.4975 2.5C10.2578 2.5 12.4958 4.73877 12.4958 7.5C12.4958 10.2612 10.2578 12.5 7.4975 12.5Z",
  fill: "#6F62FF"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "-5 -5 29 30",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.9ff8d7e2.svg";
export { ForwardRef as ReactComponent };